import { ChunkAPI } from "../../api/ChunkApi.js";
import { ChunkDataService } from "../ChunkDataService.js";
import { objectAssignWithOverride } from "../utils.js";
import { HttpService } from "./HttpService.js";

export class ChunkHttpService extends ChunkDataService {
  constructor(req, conf) {
    super();

    this.chunkApi = new ChunkAPI(req);

    let httpService = new HttpService(conf);
  
    objectAssignWithOverride(this, httpService);
  }

  async getChunk(app_id, id) {
    return this.chunkApi.getChunk(app_id, id);
  }

  async getChunksForId(app_id) {
    // maybe use app get api for now and return app.chunks from there

    return []; // list of chunks
  }


  getCachedMergedChunk(id, chunkHashesList) {
    // implementation doesnt have cached
  }

  getMergedChunkForIDList(id, chunkHashesList) {
    
  }


  putChunk() {
    //do nothing
  }


  static [Symbol.hasInstance](instance) {
      try {
        if (instance instanceof ChunkHttpService) return true;
        if (instance instanceof HttpService) return true; //TODO requires multiple inheritance, thhink how to overcome it
        return false;
      } catch (error) {
        return false;
      }
  }
}